import { initializeApp, FirebaseApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
  Messaging
} from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDHQ1qFjVtxSljcPa9I9-7mLcKhS5T8qZ8',
  authDomain: 'yaantrac-92c89.firebaseapp.com',
  databaseURL: 'https://yaantrac-92c89.firebaseio.com',
  projectId: 'yaantrac-92c89',
  storageBucket: 'yaantrac-92c89.firebasestorage.app',
  messagingSenderId: '46922331486',
  appId: '1:46922331486:web:fb441ab42b7db0c6488bcf',
  measurementId: 'G-GDJ3W5LEDV'
};

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

let messaging: Messaging | null = null;
let currentToken: string | null = null;

// Initialize Firebase Messaging
export const initializeMessaging = async (): Promise<Messaging | null> => {
  const supported = await isSupported();
  if (supported) {
    messaging = getMessaging(app);
    return messaging;
  } else {
    console.warn('Firebase messaging is not supported in this browser.');
    return null;
  }
};

// Request permission and get token
export const requestPermission = async (): Promise<string | null> => {
  if (!messaging) {
    await initializeMessaging();
  }

  try {
    const permission = Notification.permission;
    if (permission !== 'granted') {
      console.warn('Notification permission not granted.');
      return null;
    }

    currentToken = await getToken(messaging!, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPIDKEY
    });

    if (currentToken) {
      return currentToken;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

// Get the current token if available
export const getCurrentToken = async (): Promise<string | null> => {
  if (!messaging) {
    await initializeMessaging();
  }

  try {
    currentToken = await getToken(messaging!, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPIDKEY
    });
    return currentToken;
  } catch (err) {
    return null;
  }
};

// Handle incoming messages
export const onMessageListener = async (): Promise<any> => {
  if (!messaging) {
    await initializeMessaging();
  }

  return new Promise(resolve => {
    onMessage(messaging!, payload => {
      resolve(payload);
    });
  });
};
